import React from 'react';
import { I18n } from '@aws-amplify/core';
import { Col, Collapse } from 'antd';

import { KimLiftingHoldingCarrying } from '@/hooks';
import { useGetSummaryMessages } from '@/components/views/Report/KimLhc/Report/Steps/Result/hooks/useGetSummaryMessages';

import { CombinedRiskResult } from './CombinedRiskResult';
import { GenderRiskResult } from './GenderRiskResult';

import * as S from '../styles';

interface KimLiftingHoldingProps {
	data: KimLiftingHoldingCarrying;
}

export function KimLiftingHoldingResults({ data }: Readonly<KimLiftingHoldingProps>): JSX.Element {
	const { id, man, woman } = data;

	const womanSummary = useGetSummaryMessages(woman.risk);
	const manSummary = useGetSummaryMessages(man.risk);
	const hasSameRisk = man.risk === woman.risk;

	return (
		<Collapse ghost>
			<S.PanelCustom header={I18n.get('KIM LHC: Manual Lifting, Holding and Carrying')} key={'kim-lhc'}>
				<Col span={24}>
					{hasSameRisk ? (
						<CombinedRiskResult id={id} woman={woman} man={man} summary={womanSummary} />
					) : (
						<GenderRiskResult woman={woman} man={man} womanSummary={womanSummary} manSummary={manSummary} />
					)}
				</Col>
			</S.PanelCustom>
		</Collapse>
	);
}
